namespace $.$$ {
	export class $shm_hitalama_map_widget_float_code_sql extends $.$shm_hitalama_map_widget_float_code_sql {
		
		@ $mol_mem
		sql( next?: string ): string {
			return this.widget().code_sql().sql( next )
		}

		template_selected( next?: string ) {
			if( next === undefined ) return ''

			const widgets = $shm_hitalama_profile.current()?.templates_sql()?.Widgets_list(null)?.remote_list() ?? []
			const template = widgets.find( ( widget: $shm_hitalama_map_widget )=> {
				return widget.type() === this.widget().type() && widget.link_str() === next
			} )

			if( template ) {
				this.code( template.code() )
				this.sql( template.code_sql().sql() )
				this.title( template.title() )
			}

			return ''
		}


		@ $mol_mem
		sql_processed() {
			return $shm_hitalama_map_runtime_sql_process(this.map(), this.sql())
		}

		@ $shm_hitalama_process_wire_action
		run() {
			const input = this.sql_processed()
			const code = $shm_hitalama_map_runtime_sql_code(this.code())
			
			const res = this.map().execute( code, {
				[ '$' + 'page' ]: this.Map_page(),
				[ '$' + 'this_widget' ]: this.widget(),
				[ '$' + 'view' ]: this,
				[ '$' + 'arg' ]: input,
			} )

			return res
		}
		
	}
}
